/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type IntervalDefinitionFreqTypeEnum = "Daily" | "Monthly" | "Weekly" | "Yearly" | "%future added value";
export type OneOnOneAutopilot_org = {
    readonly id: string;
    readonly experiments: ReadonlyArray<string | null> | null;
    readonly focusTimeSavedInHours: number;
    readonly primaryOrgEmail: string;
    readonly primaryOrgCalendar: string;
    readonly oneOnOnesForCalendar: {
        readonly __typename: "EventList";
        readonly list: ReadonlyArray<{
            readonly eventKey: {
                readonly id: string;
                readonly calendarIds: ReadonlyArray<string> | null;
                readonly externalEventId: string;
                readonly orgId: string | null;
            };
            readonly recurringEventId: string | null;
            readonly recurrenceRules: {
                readonly interval: {
                    readonly interval: number;
                    readonly freqType: IntervalDefinitionFreqTypeEnum;
                } | null;
            } | null;
            readonly guestsCanModify: boolean | null;
            readonly title: string | null;
            readonly createdMillis: unknown | null;
            readonly isClockwiseEvent: boolean;
            readonly organizer: {
                readonly urnValue: string;
            } | null;
            readonly startTime: {
                readonly millis: number;
            };
            readonly endTime: {
                readonly millis: number;
            };
            readonly annotatedEvent: {
                readonly id: string;
                readonly externalEventId: string | null;
                readonly orgTags: ReadonlyArray<{
                    readonly tag: string;
                    readonly state: {
                        readonly active: boolean;
                        readonly value: string | null;
                    };
                }> | null;
            } | null;
            readonly " $fragmentRefs": FragmentRefs<"OnboardingAutopilotEvent_event">;
        }>;
    } | {
        readonly __typename: "GraphEntityError";
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly " $fragmentRefs": FragmentRefs<"OnboardingAutopilotEvent_org">;
    readonly " $refType": "OneOnOneAutopilot_org";
};
export type OneOnOneAutopilot_org$data = OneOnOneAutopilot_org;
export type OneOnOneAutopilot_org$key = {
    readonly " $data"?: OneOnOneAutopilot_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"OneOnOneAutopilot_org">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "externalEventId",
        "storageKey": null
    } as any, v2 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "millis",
            "storageKey": null
        } as any
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "OneOnOneAutopilot_org",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "experiments",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "focusTimeSavedInHours",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryOrgEmail",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryOrgCalendar",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "oneOnOnesForCalendar",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Event",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "EventKey",
                                        "kind": "LinkedField",
                                        "name": "eventKey",
                                        "plural": false,
                                        "selections": [
                                            (v0 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "calendarIds",
                                                "storageKey": null
                                            },
                                            (v1 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "orgId",
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "recurringEventId",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RecurrenceRules",
                                        "kind": "LinkedField",
                                        "name": "recurrenceRules",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "IntervalDefinition",
                                                "kind": "LinkedField",
                                                "name": "interval",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "interval",
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "freqType",
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "guestsCanModify",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "title",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "createdMillis",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "isClockwiseEvent",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Attendee",
                                        "kind": "LinkedField",
                                        "name": "organizer",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "urnValue",
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "EventTime",
                                        "kind": "LinkedField",
                                        "name": "startTime",
                                        "plural": false,
                                        "selections": (v2 /*: any*/),
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "EventTime",
                                        "kind": "LinkedField",
                                        "name": "endTime",
                                        "plural": false,
                                        "selections": (v2 /*: any*/),
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "AnnotatedEvent",
                                        "kind": "LinkedField",
                                        "name": "annotatedEvent",
                                        "plural": false,
                                        "selections": [
                                            (v0 /*: any*/),
                                            (v1 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "OrgTag",
                                                "kind": "LinkedField",
                                                "name": "orgTags",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "tag",
                                                        "storageKey": null
                                                    },
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "TagState",
                                                        "kind": "LinkedField",
                                                        "name": "state",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "active",
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "value",
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "OnboardingAutopilotEvent_event"
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "EventList",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "message",
                                "storageKey": null
                            }
                        ],
                        "type": "GraphEntityError",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "OnboardingAutopilotEvent_org"
            }
        ],
        "type": "Org",
        "abstractKey": null
    } as any;
})();
(node as any).hash = 'ef4126fcaa2e93c6e6ea5cee7bda1eb2';
export default node;
